export const genres = [
  { id: 0, name: "All" },
  { id: 1, name: "Poetry" },
  { id: 2, name: "Philosophy" },
  { id: 3, name: "Mystery" },
  { id: 4, name: "Romance" },
  { id: 5, name: "Science" },
  { id: 6, name: "Fantasy" },
  { id: 7, name: "Horror" },
  { id: 8, name: "History" },
  { id: 9, name: "Self-help" },
  { id: 10, name: "Biography" },
];

export function getGenres() {
  return genres;
}
